import React, { useEffect, useState } from "react";
import {
  checkWidgetAdminOrNot,
  URL as apiUrl,
} from "../../../../utils/Constants";
import { axiosPost } from "../../../../utils/AxiosApi";
import "./templateGallery.scss";
import TemplateCard from "./TemplateCard";

const TemplateGallery = () => {
  const [templates, setTemplates] = useState([]);

  useEffect(() => {
    axiosPost(apiUrl.getAllTemplates, {}, (response) => {
      if (response.status === 200) {
        let templates = response.data.data;
        templates.forEach((t) => {
          // assuming t.content has the HTML string
          const blob = new Blob([t.templateFormat], { type: "text/html" });
          t.url = URL.createObjectURL(blob); // assign blob URL
        });
        setTemplates(templates);
      }
    });
  }, []);
  return (
    <div
      className="tt-widgetContent-tab-holder"
      style={{ height: "79.5vh", scrollbarWidth: "none" }}
    >
      <div className="tt-group-header">Template Gallery</div>
      <div className="a4-grid">
        {templates.length > 0
          ? templates.map((t) => {
              return (
                <TemplateCard key={t.id} url={t.url} name={t.name} />
                // <div
                //     className="tt-widgetContent-tab-holder allCalendarDisplay m-3"
                //     style={{ width: "210px", height:"297px" }}
                // >
                //     <div dangerouslySetInnerHTML={{ __html: t.template }} />
                // </div>
              );
            })
          : ""}
      </div>
    </div>
  );
};

export default TemplateGallery;
